<template>
  <span class="date-range-select">
    <button
        v-on:click="setDate('previous')"
        class="btn btn-secondary me-1"
    >
        <i class="fa-light fa-chevron-left"></i>
    </button>
    <button
        v-if="type === 'day' && $moment(currentDateStart).format('DD-MM-YYYY') !== $moment().format('DD-MM-YYYY')"
        v-on:click="setDate('current')"
        class="btn btn-info me-1"
    >
        Vandaag
    </button>
    <button
        v-else-if="type === 'week' && $moment(currentDateStart).format('W-YYYY') !== $moment().format('W-YYYY')"
        v-on:click="setDate('current')"
        class="btn btn-info me-1"
    >
        Deze week
    </button>
    <button
        v-else-if="type === 'month' && $moment(currentDateStart).format('MM-YYYY') !== $moment().format('MM-YYYY')"
        v-on:click="setDate('current')" class="btn btn-info me-1"
    >
        Deze maand
    </button>
    <button
        v-else v-on:click="setDate('current')" class="btn btn-secondary me-1"
    >
        {{ currentName }}
    </button>
    <button
        v-on:click="setDate('next')"
        class="btn btn-secondary me-1"
    >
        <i class="fa-light fa-chevron-right"></i>
    </button>
  </span>
</template>

<script>
export default {
  name: 'date-range-select',
  props: {
    type: {
      type: String
    },
    listenToDate: {
      type: String
    },
    emitOnCreated: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      emit: true,
      currentDateStart: null,
      currentDateEnd: null
    }
  },
  watch: {
    listenToDate (date) {
      this.setDate2(date)
    }
  },
  created () {
    if (this.emitOnCreated === false) {
      this.emit = false
    }
    if (this.listenToDate) {
      this.setDate('date', this.listenToDate)
    } else {
      this.setDate('current')
    }
    if (this.type === 'day') {
      this.currentName = 'Vandaag'
    } else if (this.type === 'week') {
      this.currentName = 'Deze week'
    } else if (this.type === 'month') {
      this.currentName = 'Deze maand'
    }
    this.emit = true
  },
  methods: {
    setDate2 (date) {
      this.currentDateStart = this.$moment(date).format('YYYY-MM-DD')
      this.currentDateEnd = this.$moment(date).format('YYYY-MM-DD')
    },
    setDate (goTo, specificDate) {
      specificDate = specificDate || null
      var dateStart = this.currentDateStart || null
      var dateEnd = this.currentDateEnd || null
      if (this.type === 'day') {
        if (goTo === 'current') {
          dateStart = this.$moment().format('YYYY-MM-DD')
          dateEnd = this.$moment().format('YYYY-MM-DD')
        } else if (goTo === 'next') {
          dateStart = this.$moment(dateStart).add('1', 'days').startOf('days').format('YYYY-MM-DD')
          dateEnd = this.$moment(dateEnd).add('1', 'days').endOf('days').format('YYYY-MM-DD')
        } else if (goTo === 'previous') {
          dateStart = this.$moment(dateStart).subtract('1', 'days').startOf('days').format('YYYY-MM-DD')
          dateEnd = this.$moment(dateEnd).subtract('1', 'days').endOf('days').format('YYYY-MM-DD')
        } else if (goTo === 'date' && specificDate) {
          dateStart = this.$moment(specificDate).startOf('days').format('YYYY-MM-DD')
          dateEnd = this.$moment(specificDate).endOf('days').format('YYYY-MM-DD')
        }
      } else if (this.type === 'week') {
        if (goTo === 'current') {
          dateStart = this.$moment().startOf('week').format('YYYY-MM-DD')
          dateEnd = this.$moment().endOf('week').format('YYYY-MM-DD')
        } else if (goTo === 'next') {
          dateStart = this.$moment(dateStart).add('1', 'weeks').startOf('week').format('YYYY-MM-DD')
          dateEnd = this.$moment(dateEnd).add('1', 'weeks').endOf('week').format('YYYY-MM-DD')
        } else if (goTo === 'previous') {
          dateStart = this.$moment(dateStart).subtract('1', 'weeks').startOf('week').format('YYYY-MM-DD')
          dateEnd = this.$moment(dateEnd).subtract('1', 'weeks').endOf('week').format('YYYY-MM-DD')
        }
      } else if (this.type === 'month') {
        if (goTo === 'current') {
          dateStart = this.$moment().startOf('month').format('YYYY-MM-DD')
          dateEnd = this.$moment().endOf('month').format('YYYY-MM-DD')
        } else if (goTo === 'next') {
          dateStart = this.$moment(dateStart).add('1', 'months').startOf('months').format('YYYY-MM-DD')
          dateEnd = this.$moment(dateEnd).add('1', 'months').endOf('months').format('YYYY-MM-DD')
        } else if (goTo === 'previous') {
          dateStart = this.$moment(dateStart).subtract('1', 'months').startOf('months').format('YYYY-MM-DD')
          dateEnd = this.$moment(dateEnd).subtract('1', 'months').endOf('months').format('YYYY-MM-DD')
        }
      }
      this.currentDateStart = dateStart
      this.currentDateEnd = dateEnd
      if (this.emit === true) {
        this.$emit('changeDateRange', {
          dateStart: dateStart,
          dateEnd: dateEnd
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
